import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import QueuedCalls from '../dashboard/widgets/queuedcalls';
import QueuedChats from '../dashboard/widgets/queuedchats';
import IncomingCallsSummary from '../dashboard/widgets/incomingcallssummary';
import OutgoingCallsSummary from '../dashboard/widgets/outgoingcallssummary';
import SocialSummary from '../dashboard/widgets/socialsummary';
import AgentsPanel from '../dashboard/widgets/agentspanel/agentspanel';
import UserCampaignStatus from './widgets/usercampaignstatus';
import axios from 'axios';
import MonitorService from 'src/controllers/MonitorService';
import { Row, Col } from 'react-bootstrap';
import { setMonitorToken, setMonitorConnected, setMonitorConnectionLost } from 'src/redux/agentSlice';

export const componentRegistry = {
    QueuedCalls,
    QueuedChats,
    IncomingCallsSummary,
    OutgoingCallsSummary,
    SocialSummary,
    AgentsPanel,
    UserCampaignStatus
};
class Extra extends Component {

    constructor(props) {
        super(props)
        this.state = {
            extra: null
        }

    }

    componentDidMount() {
        axios.get("widgets.json").then((response) => {
            this.setState({ extra: response?.data });
        }).catch((error) => {
            console.error("Error fetching JSON:", error);
        });
    }

    componentWillUnmount() {
    }
    
    render() {
        return (
            <div style={{ position: "relative", right: "10px" }}>
                {
                    (this.state.extra?.widgets?.length > 0 && this.props.connected) &&
                    <Row>
                        {
                            this.state.extra?.widgets.map((w, i) => {
                                const Component = componentRegistry[w.type];
                                return (<Col lg={w.width}><Component key={i} /></Col>)
                            })
                        }

                    </Row>
                }
            </div>)
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.agent.monitorToken,
        userId: state.agent.userId,
        connected: state.agent.monitorConnected,
        connectionLost: state.agent.monitorConnectionLost
    };
};
export default compose(connect(mapStateToProps, { setMonitorToken }), withTranslation())(Extra);